import { render, staticRenderFns } from "./DropzoneHeader.vue?vue&type=template&id=356d1330"
import script from "./DropzoneHeader.vue?vue&type=script&lang=js"
export * from "./DropzoneHeader.vue?vue&type=script&lang=js"
import style0 from "./DropzoneHeader.vue?vue&type=style&index=0&id=356d1330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports